/* eslint-disable react/prop-types */
// Argon Dashboard 2 MUI components
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonBadge from "components/ArgonBadge";

import VisibilityIcon from "@mui/icons-material/Visibility";
import DeleteIcon from "@mui/icons-material/Delete";
import { Button } from "@mui/material";

// Images
import team2 from "assets/images/team-2.jpg";
import team3 from "assets/images/team-3.jpg";
import team4 from "assets/images/team-4.jpg";

import { Link } from "react-router-dom";

function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="full" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

function Function({ job, org }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {job}
      </ArgonTypography>
      <ArgonTypography variant="caption" color="secondary">
        {org}
      </ArgonTypography>
    </ArgonBox>
  );
}

function StudentData({ student, client, to }) {
  return (
    <ArgonBox display="flex" flexDirection="column">
      <ArgonTypography
        component={Link}
        to={to || "/classes/classSummary"}
        color="primary"
        variant="caption"
        fontWeight="medium"
      >
        {student}
      </ArgonTypography>
      {/* <ArgonTypography component={Link} to="/classes/classSummary" color="primary" variant="caption" fontWeight="medium">Client-{client}</ArgonTypography> */}
    </ArgonBox>
  );
}

// Attendance component
function AttendanceProgress({ percentage, label = "Attendance" }) {
  return (
    <ArgonBox>
      {/* Label */}
      <ArgonBox display="flex" justifyContent="space-between" mb={1}>
        <ArgonTypography variant="caption" fontWeight="medium" color="text">
          {"12 July 2024"}
        </ArgonTypography>
      </ArgonBox>

      {/* Progress Bar Container */}
      <ArgonBox
        width="180%"
        height="10px"
        bgColor="grey-200"
        borderRadius="lg"
        position="relative"
        overflow="hidden"
      >
        {/* Progress Fill */}
        <ArgonBox
          width={`${percentage}%`}
          height="100%"
          // bgColor={percentage >= 80 ? "success" : percentage >= 60 ? "warning" : "error"}
          bgColor="primary"
          borderRadius="lg"
          position="absolute"
          top={0}
          left={0}
        />
      </ArgonBox>
    </ArgonBox>
  );
}

const classMgtTableData = (handleDeleteClick, classData = []) => ({
  columns: [
    { name: "sno", align: "center" }, // Serial Number
    { name: "className", align: "left" }, // Class name
    { name: "students", align: "left" }, // Students list
    { name: "parent", align: "left" }, // Parent
    { name: "tutor", align: "left" }, // Tutor
    { name: "last Attendance", align: "left" }, // Last Attendance Date
    { name: "classDetails", align: "left" }, // Class Details (total/completed)
    { name: "mode", align: "left" }, // Mode (online/offline)
    { name: "status", align: "center" }, // Status (Active, Hold, etc.)
    { name: "action", align: "center" }, // Actions (Edit/Delete/View)
  ],

  rows:
    classData && classData.length > 0
      ? classData.map((session, index) => ({
          sno: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {index + 1}
            </ArgonTypography>
          ),
          className: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.student?.name || "N/A"}_{session.tutor?.name || "N/A"}_
              {session.student?.class || "N/A"}
            </ArgonTypography>
          ),
          students: (
            <StudentData
              student={session.student?.name || "N/A"}
              to={`/classes/classSummary/${session._id}`}
            />
          ),
          parent: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.parentId?.fullName || session.parentId?.name || "N/A"}
            </ArgonTypography>
          ),
          tutor: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.tutor?.name || "N/A"}
            </ArgonTypography>
          ),
          "last Attendance": (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.attendance?.startTime
                ? new Date(session.attendance.startTime).toLocaleDateString()
                : "Not Started"}
            </ArgonTypography>
          ),
          classDetails: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.completedClasses || 0}/{session.totalClasses || 0}
            </ArgonTypography>
          ),
          mode: (
            <ArgonTypography variant="caption" color="text" fontWeight="medium">
              {session.classType || "N/A"}
            </ArgonTypography>
          ),
          status: (
            <ArgonBadge
              variant="gradient"
              badgeContent={session.status || "N/A"}
              color={
                session.status === "ONGOING" || session.status === "CREATED"
                  ? "success"
                  : session.status === "ON_HOLD"
                  ? "warning"
                  : session.status === "COMPLETED"
                  ? "info"
                  : session.status === "DISCONTINUED"
                  ? "error"
                  : "secondary"
              }
              size="xs"
              container
            />
          ),
          action: (
            <ArgonBox display="flex" alignItems="center" gap={0}>
              <Button
                variant="text"
                size="large"
                component={Link}
                to={`/classes/classSummary/${session._id}`}
                sx={{ minWidth: "12px", p: 0 }}
              >
                <VisibilityIcon color="primary" />
              </Button>
              <Button
                variant="text"
                size="large"
                sx={{ minWidth: "32px", p: 0 }}
                onClick={() => handleDeleteClick(session._id)}
              >
                <DeleteIcon color="error" />
              </Button>
            </ArgonBox>
          ),
        }))
      : [
          {
            sno: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            className: (
              <ArgonTypography variant="caption" color="error" fontWeight="medium">
                No classes found. Please check your filters or add new classes.
              </ArgonTypography>
            ),
            students: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            parent: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            tutor: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            "last Attendance": (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            classDetails: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            mode: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            status: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
            action: (
              <ArgonTypography variant="caption" color="text" fontWeight="medium">
                -
              </ArgonTypography>
            ),
          },
        ],

  //   rows: [
  //     {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //              <ArgonBox display="flex" alignItems="center" gap={0}>
  //                  {/* View Icon */}
  //                   <Button variant="text"  size="large" component={Link} to="/classes/classSummary" sx={{minWidth:"12px",p:0}} >
  //                     <VisibilityIcon color="primary"/>
  //                   </Button>
  //                   {/* Delete icon */}
  //                  <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
  //                  onClick={() =>handleDeleteClick()}
  //                  >
  //                    <DeleteIcon color="error"/>
  //                  </Button>

  //                </ArgonBox>
  //              ),
  // },
  //    {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //   <ArgonBox display="flex" alignItems="center" gap={1}>
  //     {/* View Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
  //       <VisibilityIcon/>
  //     </ArgonTypography>

  //     {/* Delete Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
  //     <DeleteIcon/>
  //     </ArgonTypography>
  //   </ArgonBox>
  // ),
  // },
  //    {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //   <ArgonBox display="flex" alignItems="center" gap={1}>
  //     {/* View Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
  //       <VisibilityIcon/>
  //     </ArgonTypography>

  //     {/* Delete Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
  //     <DeleteIcon/>
  //     </ArgonTypography>
  //   </ArgonBox>
  // ),
  // },
  //    {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //   <ArgonBox display="flex" alignItems="center" gap={1}>
  //     {/* View Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
  //       <VisibilityIcon/>
  //     </ArgonTypography>

  //     {/* Delete Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
  //     <DeleteIcon/>
  //     </ArgonTypography>
  //   </ArgonBox>
  // ),
  // },
  //    {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //   <ArgonBox display="flex" alignItems="center" gap={1}>
  //     {/* View Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
  //       <VisibilityIcon/>
  //     </ArgonTypography>

  //     {/* Delete Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
  //     <DeleteIcon/>
  //     </ArgonTypography>
  //   </ArgonBox>
  // ),
  // },
  //    {
  //       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"1"}</ArgonTypography>,
  //       Class_name: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Mathematics Grade 10"}</ArgonTypography>,
  //       student:  <StudentData student={"Aarav Sharma"} client={"Rajesh Sharma"} />,
  //       tutor: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Dr.Priya Patel"}</ArgonTypography>,
  //       Last_attendance_marked: <AttendanceProgress percentage={"50"}/>,
  //       mode:<ArgonTypography variant="caption" color="text" fontWeight="medium">{"7354722929"}</ArgonTypography>,
  //       status:(<ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />),
  //          action: (
  //   <ArgonBox display="flex" alignItems="center" gap={1}>
  //     {/* View Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="primary" fontWeight="medium">
  //       <VisibilityIcon/>
  //     </ArgonTypography>

  //     {/* Delete Icon */}
  //     <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium">
  //     <DeleteIcon/>
  //     </ArgonTypography>
  //   </ArgonBox>
  // ),
  // },

  //     // {
  //     //   author: <Author image={team2} name="John Michael" email="john@creative-tim.com" />,
  //     //   function: <Function job="Manager" org="Organization" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       23/04/18
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },

  //     // {
  //     //   author: <Author image={team3} name="Alexa Liras" email="alexa@creative-tim.com" />,
  //     //   function: <Function job="Programator" org="Developer" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       11/01/19
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },
  //     // {
  //     //   author: <Author image={team4} name="Laurent Perrier" email="laurent@creative-tim.com" />,
  //     //   function: <Function job="Executive" org="Projects" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       19/09/17
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },
  //     // {
  //     //   author: <Author image={team3} name="Michael Levi" email="michael@creative-tim.com" />,
  //     //   function: <Function job="Programator" org="Developer" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="online" color="success" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       24/12/08
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },
  //     // {
  //     //   author: <Author image={team2} name="Richard Gran" email="richard@creative-tim.com" />,
  //     //   function: <Function job="Manager" org="Executive" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       04/10/21
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },
  //     // {
  //     //   author: <Author image={team4} name="Miriam Eric" email="miriam@creative-tim.com" />,
  //     //   function: <Function job="Programtor" org="Developer" />,
  //     //   status: (
  //     //     <ArgonBadge variant="gradient" badgeContent="offline" color="secondary" size="xs" container />
  //     //   ),
  //     //   employed: (
  //     //     <ArgonTypography variant="caption" color="secondary" fontWeight="medium">
  //     //       14/09/20
  //     //     </ArgonTypography>
  //     //   ),
  //     //   action: (
  //     //     <ArgonTypography
  //     //       component="a"
  //     //       href="#"
  //     //       variant="caption"
  //     //       color="secondary"
  //     //       fontWeight="medium"
  //     //     >
  //     //       Edit
  //     //     </ArgonTypography>
  //     //   ),
  //     // },
  //   ],
});

export default classMgtTableData;
